
export class EvaluationDetail
{
    userID: number;
    evaluationDetailID : number;
    questionID : boolean;
    question = [];
    answerEvaluationDetails = [];
    isView;  
    constructor(){}
}